import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { ButtonVariant } from '@components/Button';
import SearchableSelect from '@components/SearchableSelect';
import useGetUserMarketingId from '@hooks/reactQueryHooks/useGetUserMarketingId';
import { PRODUCT_NAMES_BY_ID_TRANSLATED } from '@src/constants';
import { useAuthenticationContext } from '@src/context/AuthenticationContext';
import { SortDirections, sortList } from '@src/utils/utils';

import { useAuthorizationContext } from '../..';

const SelectMarketingId: React.FC = () => {
  const { t } = useTranslation();
  const { doLogout } = useAuthenticationContext();
  const { handleSelectMarketingId } = useAuthorizationContext();
  const { data: userMarketingIdData = [] } = useGetUserMarketingId();

  const [selectedMarketingId, setSelectedMarketingId] = useState('');

  const marketingIdOptions = useMemo(() => {
    const options = userMarketingIdData.map(userMarketingId => {
      const productName = t(
        PRODUCT_NAMES_BY_ID_TRANSLATED[userMarketingId.product_id],
      );

      const productNameToDisplay = productName ? `- ${productName}` : '';
      return {
        label: `${userMarketingId.marketing_id} - ${userMarketingId.role} - ${userMarketingId.branch_name} ${productNameToDisplay}`,
        value: userMarketingId.marketing_id,
      };
    });

    return sortList(options, 'label', SortDirections.Ascending);
  }, [t, userMarketingIdData]);
  return (
    <div className="w-full max-w-[664px] sm:px-[64px] sm:py-[40px]">
      <h1 className="text-[24px] sm:text-[36px] font-semibold py-4 mb-6">
        {t('authGate.selectMarketingId')}
      </h1>
      <SearchableSelect
        name="select-marketing-id"
        dataTestId="select-marketing-id"
        label={t('authGate.marketingId')}
        value={selectedMarketingId}
        onChange={option => setSelectedMarketingId(option?.value as string)}
        options={marketingIdOptions}
        containerClassName="mb-6"
      />
      <Button
        disabled={!selectedMarketingId}
        dataTestId="next-button"
        className="w-full px-6 py-4 text-[16px] mb-6"
        onClick={() => handleSelectMarketingId(selectedMarketingId)}
      >
        {t('authGate.next')}
      </Button>
      <Button
        variant={ButtonVariant.Secondary}
        dataTestId="back-to-login-button"
        onClick={doLogout}
        className="w-full px-6 py-4 text-[16px]"
      >
        {t('authGate.backToLogin')}
      </Button>
    </div>
  );
};

export default SelectMarketingId;
